<template>
  <div
    v-if="loading"
    class="lottie-card"
    style="
      position: fixed;
      z-index: 999;
      background-color: rgba(255, 255, 255, 0.5);

      width: 100%;
    "
  >
    <Lottie
      :width="300"
      style="height: 100vh"
      :options="animationOptions"
      @animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import * as LoadingAnimation from '@/assets/animations/loading-dots.json'
import { mapState } from 'vuex'

export default {
  name: 'Loading',
  data: function () {
    return {
      animationOptions: { animationData: LoadingAnimation.default },
      animationSpeed: 1,
      anim: null,
    }
  },
  methods: {
    handleAnimation: (anim) => {
      try {
        this.anim = anim
      } catch (error) {}
    },
  },
  computed: { ...mapState('ui', ['loading']) },
  components: {
    Lottie,
  },
}
</script>
